<button
  type="button"
  mat-stroked-button
  class="contact-us-button"
  (click)="openContactUs()"
  matTooltip="Email the LOQT team"
  aria-label="Contact us by email">
  <mat-icon>mail_outline</mat-icon>
  <span>Contact us</span>
</button>
